import { Injectable } from '@angular/core';
import { RouteCommands, RouteInput } from '@ebeihilfe/core';

@Injectable({
  providedIn: 'root',
})
export class FormatRouteService {
  /**
   * Formatiert eine Route für den Angular Router.
   *
   * Wenn die Route ein String mit einer Overlay-Notation ist
   * z.B "/meine-antraege/(overlay:assistent)", wird sie in ein
   * Array mit dem Hauptpfad und einem Outlets-Objekt für den Overlay-Outlet umgewandelt.
   *
   * Andernfalls wird die Route unverändert zurückgegeben.
   *
   * @param route - Die Eingabe-Route als String oder als Array von RouteCommands.
   * @returns Ein Router Commands-Array oder der ursprüngliche String/Array, abhängig vom Format der Eingabe.
   */
  public formatRoute(route: RouteInput): RouteCommands | string {
    if (typeof route === 'string') {
      const overlayMatch = route.match(/^\/?(.*?)\/\(overlay:(.+)\)$/);
      if (overlayMatch) {
        const [, primaryPath, overlay] = overlayMatch;
        return [`/${primaryPath}`, { outlets: { overlay: [overlay] } }];
      }
    }
    return route;
  }
}
